var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 0H1.71429C0.7675 0 0 0.7675 0 1.71429V14.2857C0 15.2325 0.7675 16 1.71429 16H14.2857C15.2325 16 16 15.2325 16 14.2857V1.71429C16 0.7675 15.2325 0 14.2857 0ZM6.86818 3.42857H9.13182C9.37768 3.42857 9.57314 3.635 9.55975 3.8805L9.29482 8.73764C9.28243 8.96493 9.0945 9.14286 8.86689 9.14286H7.13311C6.9055 9.14286 6.71757 8.96493 6.70518 8.73764L6.44025 3.8805C6.42686 3.635 6.62232 3.42857 6.86818 3.42857ZM8 13.0714C7.09268 13.0714 6.35714 12.3359 6.35714 11.4286C6.35714 10.5213 7.09268 9.78572 8 9.78572C8.90732 9.78572 9.64286 10.5213 9.64286 11.4286C9.64286 12.3359 8.90732 13.0714 8 13.0714Z",
    fill: "#DA515E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRed);
export default __webpack_public_path__ + "static/media/ExclamationRed.0d496da37c8c11a050f07c5ebd2e83a8.svg";
export { ForwardRef as ReactComponent };